var map = {
	"./audio-icon.png": "2e40",
	"./excel-icon.png": "ae8c",
	"./image-icon.png": "f80c",
	"./pdf-icon.png": "0e4e",
	"./ppt-icon.png": "ba61",
	"./unknown-icon.png": "50d6",
	"./video-icon.png": "fb9e",
	"./word-icon.png": "c7a8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4383";